import React from "react";
import { Link } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import ReactGA from "react-ga4";

import { CategoryNameHr, ModuleNameHr, PageRoute, QueryParam } from "../../models";
import { getIconUrl } from "../../services/asset";
import { stringifyURI } from "../../services/utils";
import { SimilarModelRef } from "../../typings/interfaces";

import styles from "./similarModelsSection.scss";

const formatAdsCount = (n: number) => `${n} ${n === 1 ? "oglas" : "oglasa"}`;

interface SimilarModelsSectionProps {
  resources: any;
  similarModels: SimilarModelRef[];
  currentMakeName?: string;
  currentModelName?: string;
}

interface ResolvedModel {
  key: string;
  makeName: string;
  modelName: string;
  adCount?: number;
  url: string;
}

const resolveModel = (resources: any, similar: SimilarModelRef) => {
  if (!resources || !resources.children) return null;
  for (let i = 0; i < resources.children.length; i++) {
    const make = resources.children[i];
    if (make.id === similar.makeId) {
      if (!make.children) return null;
      for (let j = 0; j < make.children.length; j++) {
        const model = make.children[j];
        if (model.id === similar.modelId) {
          // Only includeModelIds — model already implies its make, and
          // adding includeMakeIds surfaces a redundant whole-make filter
          // chip alongside the model chip. Matches AvailableAdsWidget.
          const query = {
            module: ModuleNameHr.vehicles,
            category: CategoryNameHr.car,
            includeModelIds: [similar.modelId]
          };
          const url =
            `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}/${make.route}/${model.route}${PageRoute.search}${stringifyURI(query, QueryParam.searchQuery)}`;
          return {
            key: `${similar.makeId}-${similar.modelId}`,
            makeName: make.name,
            modelName: model.name,
            adCount: similar.adCount,
            url
          };
        }
      }
    }
  }
  return null;
};

const SimilarModelsSection = (props: SimilarModelsSectionProps) => {
  const { resources, similarModels, currentMakeName, currentModelName } = props;

  if (!similarModels || similarModels.length === 0) {
    return null;
  }

  const resolved: ResolvedModel[] = [];
  similarModels.forEach(s => {
    const r = resolveModel(resources, s);
    if (r) resolved.push(r);
  });

  if (resolved.length === 0) {
    return null;
  }

  const intro = currentMakeName && currentModelName
    ? `Ako razmišljate o modelu ${currentMakeName} ${currentModelName}, možda će vam biti zanimljivi:`
    : "Ako razmišljate o ovom modelu, možda će vam biti zanimljivi i:";

  const handleModelClick = () => {
    ReactGA.event({
      category: "Informacije o modelu",
      action: "Click",
      label: "Pogledani slični modeli"
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          className={styles.headerIcon}
          src={getIconUrl("similar-models.svg")}
          alt=""
        />
        <h2 className={styles.title}>Slični modeli koje vrijedi pogledati</h2>
      </div>
      <p className={styles.intro}>{intro}</p>
      <ul className={styles.list}>
        {resolved.map(model => (
          <li key={model.key} className={styles.item}>
            <Link to={model.url} className={styles.row} onClick={handleModelClick}>
              <span className={styles.name}>
                {model.makeName} {model.modelName}
              </span>
              <span className={styles.meta}>
                {typeof model.adCount === "number" && (
                  <span className={styles.count}>{formatAdsCount(model.adCount)}</span>
                )}
                <RightOutlined className={styles.chevron} />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimilarModelsSection;



// WEBPACK FOOTER //
// ./src/containers/MakeModelInfoPage/SimilarModelsSection.tsx